module.exports = __webpack_public_path__ + "static/bg-vermelho-1e02e0c84981580a9244f9b8efb4f598.jpg";